document.addEventListener('DOMContentLoaded', function() {
  console.log('Script iniciado');

  // Remover estilos inline que puedan interferir
  document.querySelectorAll('.sub-menu-block').forEach(submenu => {
    submenu.removeAttribute('style');
  });

  // Manejar menús principales
  const menuItems = document.querySelectorAll('.megamenu_megamenu');
  menuItems.forEach((item, index) => {
    const link = item.querySelector('.dt-sc-nav-link');
    const submenu = item.querySelector('.sub-menu-block');
    
    if (link && submenu) {
      // Asegurarse que el contenedor tenga posición relativa
      item.style.position = 'relative';
      
      // Eventos para el menú principal
      item.addEventListener('mouseenter', () => {
        console.log('Mouse enter en menú principal');
        submenu.style.setProperty('display', 'block', 'important');
        submenu.classList.remove('is-hidden');
      });

      item.addEventListener('mouseleave', () => {
        console.log('Mouse leave en menú principal');
        submenu.style.setProperty('display', 'none', 'important');
        submenu.classList.add('is-hidden');
      });
    }
  });

  // Manejar submenús
  const subMenuItems = document.querySelectorAll('.sub-menu-lists > li.menu-item-has-children');
  subMenuItems.forEach((item, index) => {
    const submenu = item.querySelector('.sub-menu-block');
    
    if (submenu) {
      // Asegurarse que el contenedor tenga posición relativa
      item.style.position = 'relative';
      
      item.addEventListener('mouseenter', () => {
        console.log('Mouse enter en submenú');
        submenu.style.setProperty('display', 'block', 'important');
        submenu.classList.remove('is-hidden');
      });

      item.addEventListener('mouseleave', () => {
        console.log('Mouse leave en submenú');
        submenu.style.setProperty('display', 'none', 'important');
        submenu.classList.add('is-hidden');
      });
    }
  });
});